import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { take } from 'rxjs/operators';
import { AuthService } from 'src/app/core/account/auth.service';
import { User } from 'src/app/core/account/user.model';
import { Contact } from '../models/contact.model';
import { Scope } from '../models/scope.model';
import { ContactService } from '../services/contact.service';
import { GlobalService } from '../services/global.service';
import { IdentityService } from '../services/identity.service';

@Component({
    selector: 'app-comm-scope',
    templateUrl: './comm-scope.component.html',
    styleUrls: ['./comm-scope.component.scss'],
    standalone: false
})
export class CommScopeComponent implements OnInit {
  @Output() scopeSelected = new EventEmitter();
  scopeArr: Scope[];
  hasCommunication: boolean = false;
  hasUnique: boolean = false; // has only a single type
  hasDepartments: boolean = false;
  hasSuperGroups: boolean = false;
  hasGroups: boolean = false;
  selectedScope: number = null;
  detailedScope: number = null;
  detailedName: string = '';
  User: User = null;
  FullContactsList: Contact[];
  constructor(
    private contactService: ContactService,
    public identityService: IdentityService,
    public globalService: GlobalService,
    private authService: AuthService
  ) {}

  async ngOnInit() {
    await this.loadUser();
    this.setHasCommunication();
    await this.populateScopeArr();
    this.setHasUnique();
  }

  async loadUser() {
    this.User = await this.authService.autoLogin(1);
    if (this.User != null)
    {
      this.identityService.loadUser(this.User);
    }
  }

  setHasCommunication() {
    this.hasCommunication =
      this.identityService.permissions.indexOf('Admin') >= 0 ||
      this.identityService.permissions.indexOf('Super Admin') >= 0 ||
      this.identityService.permissions.indexOf('Communication') >= 0;
  }

  setHasUnique() {
    if (this.hasCommunication == true) this.hasUnique = false;
    else
      this.hasUnique =
        [...new Set(this.scopeArr.map((item) => item.type))].length == 1;
    if (this.hasUnique == true) {
      this.selectedScope = this.scopeArr[0].type;
      if (
        this.scopeArr.filter((a) => a.type == this.scopeArr[0].type).length == 1
      )
        this.detailedScope = this.scopeArr.filter(
          (a) => a.type == this.scopeArr[0].type
        )[0].id;
      this.detailedName = this.getSender(
        this.selectedScope,
        this.detailedScope
      );
      this.scopeSelected.emit({
        scope: this.selectedScope,
        detail: this.detailedScope,
        sender: this.detailedName,
      });
    }
  }

  getSender(scope: number, detail: number): string {
    if (scope == null || scope < 3) return 'CHURCH';
    return this.scopeArr.filter((a) => a.type == scope && a.id == detail)[0]
      .name;
  }

  scopeChanged() {
    this.detailedScope = null;
    if (this.selectedScope < 3) {
      this.detailedName = this.getSender(
        this.selectedScope,
        this.detailedScope
      );
      this.scopeSelected.emit({
        scope: this.selectedScope,
        detail: 0,
        sender: this.detailedName,
      });
      return;
    }
    if (this.scopeArr.filter((a) => a.type == this.selectedScope).length == 1) {
      this.detailedScope = this.scopeArr.filter(
        (a) => a.type == this.selectedScope
      )[0].id;
      this.detailedName = this.detailedScope == null? '' : this.getSender(
        this.selectedScope,
        this.detailedScope
      );
      this.detailChanged();
    }
    this.scopeSelected.emit({
      scope: this.selectedScope,
      detail: this.detailedScope,
      sender: this.detailedName,
    });
  }

  detailChanged() {
    if (this.scopeArr.filter((a) => a.type == this.selectedScope).length == 1)
      this.detailedScope = this.scopeArr.filter(
        (a) => a.type == this.selectedScope
      )[0].id;
    this.detailedName = this.detailedScope == null? '' : this.getSender(this.selectedScope, this.detailedScope);
    this.scopeSelected.emit({
      scope: this.selectedScope,
      detail: this.detailedScope,
      sender: this.detailedName,
    });
  }

  async populateScopeArr() {
    this.scopeArr = await this.contactService.getScopeHierarchy();
    this.hasDepartments = this.scopeArr.findIndex((a) => a.type == 3) >= 0;
    this.hasSuperGroups = this.scopeArr.findIndex((a) => a.type == 4) >= 0;
    this.hasGroups = this.scopeArr.findIndex((a) => a.type == 5) >= 0;
  }

  getScopeArr() {
    var scpArr = this.scopeArr.filter((a) => a.type == this.selectedScope);
    return scpArr;
  }
}
